import { render, staticRenderFns } from "./IconStop.vue?vue&type=template&id=6ade80d2&scoped=true"
import script from "./IconStop.vue?vue&type=script&lang=js"
export * from "./IconStop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ade80d2",
  null
  
)

export default component.exports